export enum Renovation {
    UNKNOWN = 0,
    EURO = 1,
    COSMETIC = 2,
    DESIGNED = 3,
    NEED = 4,
    NONE = 5,
}
